import { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import styles from './Share.module.css';

/**
 * 分享按钮组件
 * 提供多种分享渠道
 */
export default function ShareButtons({
    onDownload,
    onCopyLink,
    onShare,
    isGenerating,
    posterReady
}) {
    const { language } = useLanguage();
    const [copySuccess, setCopySuccess] = useState(false);

    const handleCopyLink = async () => {
        const success = await onCopyLink();
        if (success) {
            setCopySuccess(true);
            setTimeout(() => setCopySuccess(false), 2000);
        }
    };

    const labels = {
        saveImage: { zh: '保存图片', en: 'Save Image', de: 'Bild speichern' },
        copied: { zh: '已复制', en: 'Copied!', de: 'Kopiert!' },
        copyLink: { zh: '复制链接', en: 'Copy Link', de: 'Link kopieren' },
        share: { zh: '更多分享', en: 'Share', de: 'Teilen' }
    };

    const buttons = [
        {
            id: 'download',
            icon: '📥',
            label: labels.saveImage[language] || labels.saveImage.en,
            onClick: onDownload,
            primary: true,
            disabled: !posterReady || isGenerating
        },
        {
            id: 'copy',
            icon: copySuccess ? '✅' : '🔗',
            label: copySuccess
                ? (labels.copied[language] || labels.copied.en)
                : (labels.copyLink[language] || labels.copyLink.en),
            onClick: handleCopyLink,
            disabled: isGenerating
        },
        {
            id: 'share',
            icon: '📤',
            label: labels.share[language] || labels.share.en,
            onClick: onShare,
            disabled: !posterReady || isGenerating,
            // 仅在支持 Web Share API 时显示
            hidden: typeof navigator === 'undefined' || !navigator.share
        }
    ];

    return (
        <div className={styles.shareButtons}>
            {buttons.filter(btn => !btn.hidden).map(button => (
                <button
                    key={button.id}
                    className={`${styles.shareBtn} ${button.primary ? styles.primaryBtn : ''}`}
                    onClick={button.onClick}
                    disabled={button.disabled}
                >
                    <span className={styles.btnIcon}>{button.icon}</span>
                    <span className={styles.btnLabel}>{button.label}</span>
                </button>
            ))}
        </div>
    );
}
